import React from "react";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import common from "../../utils/common";

const useStyles = makeStyles(() => {
    return {
        miniCardImageWrapper: {
            position: "relative",
            width: "100%",
            paddingTop: "100%",
            backgroundColor: "#ffffff",
            overflow: "hidden",
        },
        miniCardImage: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "& img": {
                objectFit: "contain",
                width: "100%",
                height: "100%",
            },
        },
        miniCardContent: {
            display: "flex",
            flexDirection: "column",
            flexWrap: "nowrap",
            alignItems: "center",
            padding: "8px",
        },
        miniCardPrice: {
            color: "#FFF",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "20.52px",
            letterSpacing: "0.103px",
            marginTop: "4px",
        },
        miniCardMetadata: {
            marginLeft: "16px",
            width: "100%",
        },
        miniCardButton: {
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "center",
            border: 0,
            alignSelf: "stretch",
            backgroundColor: "#000",
            textAlign: "center",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "18px",
            letterSpacing: "1px",
            color: "#ffffff",
            textDecoration: "none",
            padding: "8px 12px",
            cursor: "pointer",
            borderRadius: "23px",
            "&:hover": {
                transform: "scale(1.03)",
            },
        },
        miniCardCTA: {
            paddingTop: "4px",
            width: "75%",
        },
    };
});

const ProductsCollectionItem = ({ item, userId }) => {
    const classes = useStyles();
    const { image_url, title, link_url, price, brand, product_id } = item;

    return (
        <Box>
            <div className={classes.miniCardContent}>
                <div className={classes.miniCardImageWrapper}>
                    <div className={classes.miniCardImage}>
                        <img src={image_url} alt={title} />
                    </div>
                </div>
                <div className={classes.miniCardMetadata}>
                    <Typography
                        my="8px"
                        fontSize={16}
                        color="#6E6E6E"
                        fontWeight={500}
                    >
                        {brand}
                    </Typography>

                    <Typography
                        fontSize={16}
                        color="#212121"
                        fontWeight={500}
                        sx={{
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            minHeight: "40px",
                        }}
                    >
                        {title}
                    </Typography>

                    <Typography
                        my="8px"
                        fontSize={16}
                        color="#212121"
                        fontWeight={500}
                    >
                        ${price}
                    </Typography>
                    <div className={classes.miniCardCTA}>
                        <a
                            className={classes.miniCardButton}
                            href={common.addSharedIdToUrl(link_url, userId, product_id)}
                            target="_blank"
                        >
                            ADD TO BAG
                        </a>
                    </div>
                </div>
            </div>
        </Box>
    );
};

export default ProductsCollectionItem;
